export default __webpack_public_path__ + "static/metin-ozer-window-graphic-71d073fcb67e73ad0423d0bb46830995.jpg";